// extracted by mini-css-extract-plugin
module.exports = {"buttonCheckBox":"classes_buttonCheckBox__3X_z9","questionFont":"classes_questionFont__1EmOY","fileLoad":"classes_fileLoad__3-ZEZ"};